import {
  IonButton,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonLabel,
  IonModal,
  IonPage,
  IonRow,
  IonTextarea,
} from "@ionic/react";
import { useHistory } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import MeasuringTape from "../components/modals/measuring-tape";
import TopLeftUserName from "../components/TopLeftUserName";
import GraphAssessmentDescriptionModal from "../components/modals/graph-assessment-description";

import {
  AddReportComments,
  GenerateTestsReport,
  GetReportComments,
} from "../services/AssessmentsService";

import { useRecoilState, useRecoilValue } from "recoil";
import {
  currentAssessmentState,
  networkConnectionStatus,
  PatientState,
} from "../data/atoms";
import { ActionType, ConversionRequired, TestType } from "../models/Enums";
import {
  GaitScore,
  Reports,
  FiveXTSScore,
  RepetitionStep,
  UpperBodyAromScore,
  RLGLScore,
  AFScore,
  BalloonPopperScore,
  VeggieSlicerScore,
  TugScore,
  FunctionalReachScore,
  MctsibScore,
} from "../models/reports";
import { PatientVM } from "../models/PatientVM";
import { GaitPercentialTable } from "../models/GaitPercentialTable";

import Loader from "../components/LoaderComponent";
import { format, formatDistanceToNow, set } from "date-fns";
import {
  convertDOBintoAge,
  convertUnit,
  getPatientAge,
  localDateTime,
} from "../utils/sharedFunction";
import { GaitTest, GetGaitFallRisk } from "../models/AssessmentRelated/Gait";
import PatientSummaryInfo from "../components/PatientSummaryInfo";
import TestWrapper from "../components/TestWrapper";
import SFImg from "../assets/images/SFImg.png";
import AAImg from "../assets/images/AAImg.png";
import EFImg from "../assets/images/EFImg.png";
import EEImg from "../assets/images/EEImg.png";
import IRImg from "../assets/images/IRImg.png";
import ERImg from "../assets/images/ERImg.png";
import CompletedEducationModal from "../components/modals/completed-education-modal";
import RemoteTherapeuticMonitoringModal from "../components/modals/remote-therapeutic-monitoring-modal";
import RtmEnabledModal from "../components/modals/rtm-enabled-modal";
import ConsentFormModal from "../components/modals/consent-form-modal";
import ChooseEpisodeModal from "../components/modals/choose-episode-modal";
import NewEpisodeModal from "../components/modals/new-episode-modal";
import { EnableDisablePatientRtm } from "../services/AuthServices";
import SetupEpisodeModal from "../components/modals/setup-episode-modal";
import { Any, any, string } from "@tensorflow/tfjs-core";
import ProactiveYouModal from "../components/modals/ProactiveYouModal";
import PatientRegistrationQRModal from "../components/modals/patient-registeration-qr-modal";
import ErrorTopToaster from "../components/ErrorTopToaster";

interface Props {
  pageHeaderText: string;
  isAssessmentCompleted?: boolean;
  location?: {
    state: {
      pageHeaderText: string;
      isAssessmentCompleted: boolean;
    };
  };
}
const PatientAssessmentSummary: React.FC<Props> = (props) => {
  const { state } = props.location || {};
  const isAssessmentCompleted =
    props.isAssessmentCompleted ?? state?.isAssessmentCompleted;

  const currentAssessment = useRecoilValue(currentAssessmentState);
  const [patientInfo, setPatientInfo] = useRecoilState(PatientState);
  const [allComments, setAllComments] = useState([]);
  const [patientAge, setpatientAge] = useState(0);
  const [assessmentTestType, setAssessmentTestType] = useState(0);
  const isFullPatient = window.location.href.includes("/full-visit-summary");
  const [openProactiveAfterClose, setOpenProactiveAfterClose] = useState(false);

  let localtime = new Date(
    new Date().setHours(
      new Date().getHours() - new Date().getTimezoneOffset() / 60,
    ),
  ).toISOString();

  function formateDateNotes(date: any) {
    return (
      (date.getMonth() > 8
        ? date.getMonth() + 1
        : "0" + (date.getMonth() + 1)) +
      "/" +
      (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
      "/" +
      date.getFullYear()
    );
  }

  let history = useHistory();

  const [assessmentSummary, setAssessmentSummary] = useState<Reports>(
    new Reports(),
  );
  const [patientDetailsRecoil, setPatientDetailsRecoil] =
    useRecoilState(PatientState);
  const [patientDetails, setPatientDetails] =
    useState<PatientVM>(patientDetailsRecoil);
  const [measuringModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isReadonly, setIsReadonly] = useState(true);
  const [loading, setLoading] = useState(false);
  const [testTime, setTestTime] = useState<string>("");
  const [masterVisitId, setMasterVisitId] = useState<number>(0);
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus,
  );
  const [isTraining, setIsTraining] = useState(false);
  const [note, setNote] = useState(
    assessmentSummary ? assessmentSummary.note : "",
  );
  const [ConsentForm, setConsentForm] = useState(false);
  const [selectedTime, setSelectedTime] = useState<string>("");
  const [CompletedEducation, setCompletedEducation] = useState(false);

  const [ChooseEpisode, setChooseEpisode] = useState(false);
  const [NewEpisode, setNewEpisode] = useState(false);
  const [SetupEpisode, setSetupEpisode] = useState(false);
  const [consentFormData, setConsentFormData] = useState<any>(null);

  // RTM State
  const [IsNewEpisode, setIsNewEpisode] = useState(false);
  const [IsRtmReenable, setIsRtmReenable] = useState(false);
  const [RtmEnabled, setRtmEnabled] = useState(false);
  const [openRtmModal, setOpenRtmModal] = useState(false);
  const [RemoteTherapeuticMonitoring, setRemoteTherapeuticMonitoring] =
    useState(false);

  const [isRtmConfigurationEnabled, setIsRtmConfigurationEnabled] =
    useState(false);
  const rtmEnabledRef = useRef(false);
  const [proactiveYouModal, setProactiveYouModal] = useState(false);

  const [registerPatientModal, setRegisterPatientModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // Clear error message after 5 seconds
  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage("");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [errorMessage]);
  let location =
    window.location.href ===
    window.location.origin + "/patient-assessment-summary";

  useEffect(() => {
    if (location) {
      setSetting();
    }

    const rtmEnabled = localStorage.getItem("isRtmEnabled") === "true";
    setIsRtmConfigurationEnabled(rtmEnabled);
    rtmEnabledRef.current = rtmEnabled;

    return () => {
      setLoading(false);
      setIsReadonly(true);
      setIsEdit(false);
    };
  }, [location]);

  useEffect(() => {
    const checkPopup = () => {
      debugger;
      const stored = localStorage.getItem("rtmEnabledRefOnCompletion");
      if (stored === "true") {
        const savedPatient = JSON.parse(
          sessionStorage.getItem("patientDetails") || "{}",
        );
        // const isNotExternalPatient = savedPatient?.externalPatientId === 0;
        const isNotExternalPatient =
          !savedPatient?.isSFTPEhrImportEnabled ||
          savedPatient?.externalPatientId !== 0;
        if (isNotExternalPatient) {
          setRemoteTherapeuticMonitoring(true);
        }
        localStorage.removeItem("rtmEnabledRefOnCompletion");
      }
    };

    // run once on mount
    checkPopup();

    // listen for custom event we dispatch
    window.addEventListener("showRtmPopupOnCompletion", checkPopup);

    return () =>
      window.removeEventListener("showRtmPopupOnCompletion", checkPopup);
  }, []);

  const getAllComments = async () => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    await GetReportComments({
      PatientId: Number(localStorage.getItem("patientServerID")),
      testId: currentAssessment.testId,
      specificWorkstationId: currentAssessment.workstationId,
      specificLocationId: currentAssessment.locationId,
      IsViewFullSummary: currentAssessment?.isViewFullSummary,
      EncryptedServerId: localStorage.getItem("EncryptedServerId"),
    }).then((res: any) => {
      console.log("comments response", res);
      if (!navigator.onLine) {
        setShowNetWorkRecoil({ isShown: true });
        return;
      }
      let sortedComments = res?.data?.reportComments?.sort(function (
        a: any,
        b: any,
      ) {
        return (
          new Date(b.commentsDate).getTime() -
          new Date(a.commentsDate).getTime()
        );
      });

      console.log("sortedComments", sortedComments);
      setAllComments(sortedComments);
      setNote("");
    });
  };

  const destrutuceReportsRspond = ({
    virtubalancetestslookup,
    visitDataVirtuBalanceTestPhaseValuesBreakup,
    visitDataVirtuBalanceTests,
    testTherapistInfo,
    virtubalancetestsconfigs,
    visitDataVirtuBalanceTestPhases,
    mobilityCalculatedValue,
    visitDataVirtuBalanceTestValues,
  }: any) => {
    debugger;
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    setAssessmentSummary((prevState: Reports) => ({
      ...prevState,
      id: visitDataVirtuBalanceTests[0]?.masterTestId,
      testType: virtubalancetestslookup[0]?.testType,
      note: visitDataVirtuBalanceTests[0]?.testComments,
      visitType: visitDataVirtuBalanceTests[0]?.visitTypeId,
      testName: virtubalancetestslookup[0]?.testName,
      therapistFirstname: testTherapistInfo[0]?.therapistFirstName,
      therapistLastName: testTherapistInfo[0]?.therapistLastName,
      time: visitDataVirtuBalanceTestPhaseValuesBreakup[0]?.time,
      usedAssistiveDevice: visitDataVirtuBalanceTestPhaseValuesBreakup?.find(
        (assessment: any) => {
          if (assessment?.property == "used_assistive_device") {
            return assessment;
          }
        },
      )?.value,
      startTime: new Date(),
      endTime: new Date(),
    }));

    console.log("virtubalancetestslookup", virtubalancetestslookup);
    console.log(
      "visitDataVirtuBalanceTestPhaseValuesBreakup",
      visitDataVirtuBalanceTestPhaseValuesBreakup,
    );

    setAssessmentTestType(visitDataVirtuBalanceTests[0]?.vbTestLookupId);
    const trainingIds = [21, 50, 51, 41];
    const isTraining = trainingIds.includes(
      visitDataVirtuBalanceTests[0]?.vbTestLookupId ?? -1,
    );
    setIsTraining(isTraining);
    if (visitDataVirtuBalanceTests[0]?.vbTestLookupId === TestType.gait) {
      visitDataVirtuBalanceTestPhaseValuesBreakup =
        visitDataVirtuBalanceTestPhaseValuesBreakup.sort(
          (a: any, b: any) => b.phaseId - a.phaseId,
        );
      // debugger

      let extractJSon = {
        id: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "fall_risk") {
                return assessment;
              }
            },
          )?.vbTestId,
        ),
        fallRisk: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "fall_risk") {
                return assessment;
              }
            },
          )?.value,
        ),
        gaitSpeed: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "gait_speed") {
                return assessment;
              } else if (assessment?.property === "velocity") {
                assessment.value = convertUnit(
                  Math.round(assessment.value),
                  ConversionRequired.CentimeterToMeter,
                );
                return assessment;
              }
            },
          )?.value,
        ),
        distance: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "distance") {
                return assessment;
              }
            },
          )?.value,
        ),
        ambulationTime: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "ambulation_time") {
                return assessment;
              }
            },
          )?.value,
        ),
        velocity: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "velocity") {
                return assessment;
              }
            },
          )?.value,
        ),
        meanNormalizedVelocity: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "mean_normlized_velocity") {
                return assessment;
              }
            },
          )?.value,
        ),
        numberOfSteps: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "number_of_steps") {
                return assessment;
              }
            },
          )?.value,
        ),

        cadence: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup?.find(
            (assessment: any) => {
              if (assessment?.property === "cadence") {
                return assessment;
              }
            },
          )?.value,
        ),
        left: {
          stepLength: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.path === "measures/score/left" &&
                  assessment?.property === "step_length"
                ) {
                  assessment.value = Math.round(
                    convertUnit(
                      assessment?.value,
                      ConversionRequired.MeterToCentiMeter,
                    ),
                  );
                  return assessment;
                }
              },
            )?.value,
          ),
        },
        right: {
          stepLength: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.path === "measures/score/right" &&
                  assessment?.property === "step_length"
                ) {
                  assessment.value = Math.round(
                    convertUnit(
                      assessment?.value,
                      ConversionRequired.MeterToCentiMeter,
                    ),
                  );
                  return assessment;
                }
              },
            )?.value,
          ),
        },
      };
      if (extractJSon.fallRisk.toString() === "NaN") {
        extractJSon.fallRisk = Math.round(
          GetGaitFallRisk(
            Math.round(
              convertUnit(
                extractJSon.gaitSpeed,
                ConversionRequired.MeterToCentiMeter,
              ),
            ),
          ),
        );
      }
      setAssessmentSummary((prevState: Reports) => ({
        ...prevState,
        score: extractJSon as GaitScore,
      }));
      debugger;
      let mobilityCheck = Number(
        visitDataVirtuBalanceTestPhaseValuesBreakup.find((assessment: any) => {
          if (assessment?.property === "gait_speed") {
            return assessment;
          } else if (assessment?.property === "velocity") {
            // assessment.value = convertUnit(Math.round(assessment.value), ConversionRequired.MeterToCentiMeter);
            return assessment;
          }
        })?.value,
      );
      if (mobilityCheck < 0.7) {
        setmobilityLevel("low");
      } else if (mobilityCheck >= 0.7 && mobilityCheck <= 1.07) {
        setmobilityLevel("medium");
      } else if (mobilityCheck > 1.07) {
        setmobilityLevel("high");
      }
    } else if (
      visitDataVirtuBalanceTests[0]?.vbTestLookupId ===
      TestType.five_x_sit_stand
    ) {
      let rep = {
        index: visitDataVirtuBalanceTestPhaseValuesBreakup.filter(
          (assessment: any) => {
            if (
              assessment?.path === "repetitions/repetition" &&
              assessment?.property === "index"
            ) {
              return assessment.value;
            }
          },
        ),
        time: visitDataVirtuBalanceTestPhaseValuesBreakup.filter(
          (assessment: any) => {
            if (
              assessment?.path === "repetitions/repetition" &&
              assessment?.property === "time"
            ) {
              return assessment.value;
            }
          },
        ),
      };
      console.log("rep", rep);
      let extractJSon = {
        id: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "time") {
                return assessment;
              }
            },
          )?.vbTestId,
        ),
        skipped: Boolean(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "skipped") {
                return assessment;
              }
            },
          )?.value,
        ),
        mobility: visitDataVirtuBalanceTestPhaseValuesBreakup.find(
          (assessment: any) => {
            if (assessment?.key === "mobility") {
              return assessment;
            }
          },
        )?.value,
        repetitions: [
          ...rep.index.map((r: any, index: any) => {
            return {
              index: Number(r.value),
              time: Number(rep.time[index].value),
            };
          }),
        ],
        overall: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (
                assessment?.key === "overall" &&
                assessment?.property === "time"
              ) {
                return assessment;
              }
            },
          )?.value,
        ),
      };
      debugger;
      console.log("extractJSon my", extractJSon);
      setAssessmentSummary((prevState: Reports) => ({
        ...prevState,
        score: extractJSon as FiveXTSScore,
      }));
      setmobilityLevel(extractJSon.mobility);
    } else if (
      visitDataVirtuBalanceTests[0]?.vbTestLookupId === TestType.upper_body_arom
    ) {
      debugger;
      let extractJSon = {
        "Shoulder Abduction": {
          left: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                debugger;
                if (
                  assessment?.key.toLowerCase() === "abduction_adduction" &&
                  (assessment?.property.toLowerCase() === "abductionleft" ||
                    assessment?.property === "left_abduction")
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          right: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() === "abduction_adduction" &&
                  (assessment?.property.toLowerCase() === "abductionright" ||
                    assessment?.property === "right_abduction")
                ) {
                  debugger;
                  return assessment;
                }
              },
            )?.value,
          ),
          imgPath: AAImg,
        },
        "Shoulder Adduction": {
          left: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                debugger;
                if (
                  assessment?.key.toLowerCase() === "abduction_adduction" &&
                  (assessment?.property.toLowerCase() === "adductionleft" ||
                    assessment?.property === "left_adduction")
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          right: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() === "abduction_adduction" &&
                  (assessment?.property.toLowerCase() === "adductionright" ||
                    assessment?.property === "right_adduction")
                ) {
                  debugger;
                  return assessment;
                }
              },
            )?.value,
          ),
          imgPath: AAImg,
        },
        "Shoulder Flexion": {
          left: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() ===
                    "shoulder_flexion_extension" &&
                  (assessment?.property.toLowerCase() ===
                    "shoulderflexionleft" ||
                    assessment?.property === "left_flexion")
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          right: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() ===
                    "shoulder_flexion_extension" &&
                  (assessment?.property.toLowerCase() ===
                    "shoulderflexionright" ||
                    assessment?.property === "right_flexion")
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          imgPath: SFImg,
        },
        "Shoulder Extension": {
          left: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() ===
                    "shoulder_flexion_extension" &&
                  (assessment?.property.toLowerCase() ===
                    "shoulderextensionleft" ||
                    assessment?.property === "left_extension")
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          right: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() ===
                    "shoulder_flexion_extension" &&
                  (assessment?.property.toLowerCase() ===
                    "shoulderextensionright" ||
                    assessment?.property === "right_extension")
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          imgPath: SFImg,
        },
        "Elbow Flexion": {
          left: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() === "elbow_flexion_extension" &&
                  (assessment?.property.toLowerCase() === "elbowflexionleft" ||
                    assessment?.property === "left_flexion")
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          right: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() === "elbow_flexion_extension" &&
                  (assessment?.property.toLowerCase() === "elbowflexionright" ||
                    assessment?.property === "right_flexion")
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          imgPath: EFImg,
        },
        "Elbow Extension": {
          left: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() === "elbow_flexion_extension" &&
                  (assessment?.property.toLowerCase() ===
                    "elbowextensionleft" ||
                    assessment?.property === "left_extension")
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          right: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() === "elbow_flexion_extension" &&
                  (assessment?.property.toLowerCase() ===
                    "elbowextensionright" ||
                    assessment?.property === "right_extension")
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          imgPath: EEImg,
        },
        "Internal Rotation": {
          left: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() ===
                    "shoulder_internal_external_rotation" &&
                  (assessment?.property.toLowerCase() === "internalleft" ||
                    assessment?.property === "left_internal")
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          right: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() ===
                    "shoulder_internal_external_rotation" &&
                  (assessment?.property.toLowerCase() === "internalright" ||
                    assessment?.property === "right_internal")
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          imgPath: IRImg,
        },
        "External Rotation": {
          left: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() ===
                    "shoulder_internal_external_rotation" &&
                  (assessment?.property.toLowerCase() === "externalleft" ||
                    assessment?.property === "left_external")
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          right: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() ===
                    "shoulder_internal_external_rotation" &&
                  (assessment?.property.toLowerCase() === "externalright" ||
                    assessment?.property === "right_external")
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          imgPath: ERImg,
        },
      };
      console.log("extractJSon my", extractJSon);
      setAssessmentSummary((prevState: Reports) => ({
        ...prevState,
        score: extractJSon as UpperBodyAromScore,
      }));
    } else if (
      visitDataVirtuBalanceTests[0]?.vbTestLookupId ===
      TestType.red_light_green_light
    ) {
      visitDataVirtuBalanceTestPhaseValuesBreakup =
        visitDataVirtuBalanceTestPhaseValuesBreakup.sort(
          (a: any, b: any) => b.phaseId - a.phaseId,
        );

      let extractJSon = {
        averageSpeed: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "average_speed") {
                return assessment;
              }
            },
          )?.value,
        ),
        distance: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "meters_displayed") {
                return assessment;
              }
            },
          )?.value,
        ),
        redLightsMissed: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "red_lights_failed") {
                return assessment;
              }
            },
          )?.value,
        ),
        metersLost: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "meters_lost") {
                return assessment;
              }
            },
          )?.value,
        ),
      };
      setAssessmentSummary((prevState: Reports) => ({
        ...prevState,
        score: extractJSon as RLGLScore,
      }));
    } else if (
      visitDataVirtuBalanceTests[0]?.vbTestLookupId === TestType.game_AF
    ) {
      visitDataVirtuBalanceTestPhaseValuesBreakup =
        visitDataVirtuBalanceTestPhaseValuesBreakup.sort(
          (a: any, b: any) => b.phaseId - a.phaseId,
        );

      let extractJSon = {
        user1PlayedSeated: visitDataVirtuBalanceTestPhaseValuesBreakup.find(
          (assessment: any) => assessment.property === "user1PlayedSeated",
        )?.value,
        goodApples: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "goodApples") {
                return assessment;
              }
            },
          )?.value,
        ),
        badApples: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "badApples") {
                return assessment;
              }
            },
          )?.value,
        ),
        goodApplePercentageCaught: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "goodApplePercentageCaught") {
                return assessment;
              }
            },
          )?.value,
        ),
        badApplePercentageCaught: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "badApplePercentageCaught") {
                return assessment;
              }
            },
          )?.value,
        ),
        applesMissed: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "applesMissed") {
                return assessment;
              }
            },
          )?.value,
        ),
        bestStreak: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "bestStreak") {
                return assessment;
              }
            },
          )?.value,
        ),
        score: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "score") {
                return assessment;
              }
            },
          )?.value,
        ),
        infiniteModeTimeLasted: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "infiniteModeTimeLasted") {
                return assessment;
              }
            },
          )?.value,
        ),
        totalLateralMovement: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "totalLateralMovement") {
                return assessment;
              }
            },
          )?.value,
        ),
        maxLateralStepLength: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "maxLateralStepLength") {
                return assessment;
              }
            },
          )?.value,
        ),
        maxLateralStepLengthRight: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "maxLateralStepLengthRight") {
                return assessment;
              }
            },
          )?.value,
        ),
        maxLateralStepLengthLeft: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "maxLateralStepLengthLeft") {
                return assessment;
              }
            },
          )?.value,
        ),
        maxLeanAngleLeft: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "maxLeanAngleLeft") {
                return assessment;
              }
            },
          )?.value,
        ),
        maxLeanAngleRight: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "maxLeanAngleRight") {
                return assessment;
              }
            },
          )?.value,
        ),
        maxArmReachLeft: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "maxArmReachLeft") {
                return assessment;
              }
            },
          )?.value,
        ),
        maxArmReachRight: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "maxArmReachRight") {
                return assessment;
              }
            },
          )?.value,
        ),
        averageArmOffsetPolled:
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) =>
              assessment.property === "averageArmOffsetPolled",
          )?.value ?? "",
        bothArmDuration: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "bothArmDuration") {
                return assessment;
              }
            },
          )?.value,
        ),
        leftArmOnlyDuration: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "leftArmOnlyDuration") {
                return assessment;
              }
            },
          )?.value,
        ),
        rightArmOnlyDuration: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "rightArmOnlyDuration") {
                return assessment;
              }
            },
          )?.value,
        ),
        difficulty: {
          movementType: visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (
                assessment?.path === "difficulty" &&
                assessment?.property === "movementType"
              ) {
                return assessment;
              }
            },
          )?.value,
          movementDifficulty: visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (
                assessment?.path === "difficulty" &&
                assessment?.property === "movementDifficulty"
              ) {
                return assessment;
              }
            },
          )?.value,
          gameTime: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (assessment?.property === "gameTime") {
                  return assessment;
                }
              },
            )?.value,
          ),
        },
      };
      setAssessmentSummary((prevState: Reports) => ({
        ...prevState,
        score: extractJSon as AFScore,
      }));
    } else if (
      visitDataVirtuBalanceTests[0]?.vbTestLookupId === TestType.hec_training
    ) {
      visitDataVirtuBalanceTestPhaseValuesBreakup =
        visitDataVirtuBalanceTestPhaseValuesBreakup.sort(
          (a: any, b: any) => b.phaseId - a.phaseId,
        );

      let extractJSon = {
        user1PlayedSeated: Boolean(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "user1PlayedSeated") {
                return assessment;
              }
            },
          )?.value === "True",
        ),
        score: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "score") {
                return assessment;
              }
            },
          )?.value,
        ),
        scorePerMinute: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "scorePerMinute") {
                return assessment;
              }
            },
          )?.value,
        ),
        averageTimeToHit: String(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "averageTimeToHit") {
                return assessment;
              }
            },
          )?.value,
        ),
        averageTimeToHitTrend: Array<number>(
          visitDataVirtuBalanceTestPhaseValuesBreakup
            .find((assessment: any) => {
              if (assessment?.property === "averageTimeToHitTrend") {
                return assessment;
              }
            })
            ?.value.split(",")
            .filter((item: string) => item !== "")
            .map((item: string) => Number(item)),
        ),
        totalBalloonsHit: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "totalBalloonsHit") {
                return assessment;
              }
            },
          )?.value,
        ),
        balloonsHitPerMinute: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "balloonsHitPerMinute") {
                return assessment;
              }
            },
          )?.value,
        ),
        totalBalloonsMissed: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "totalBalloonsMissed") {
                return assessment;
              }
            },
          )?.value,
        ),
        balloonsMissedPerMinute: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "balloonsMissedPerMinute") {
                return assessment;
              }
            },
          )?.value,
        ),
        settings: {
          time: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key === "settings" &&
                  assessment?.property === "time"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          reachDifficulty: String(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key === "settings" &&
                  assessment?.property === "reachDifficulty"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          reachDirection: String(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key === "settings" &&
                  assessment?.property === "reachDirection"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          armMode: String(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key === "settings" &&
                  assessment?.property === "armMode"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
        },
        leftHand: {
          leftAcrossHit: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key === "leftHand" &&
                  assessment?.property === "leftAcrossHit"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          leftAcrossMissed: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key === "leftHand" &&
                  assessment?.property === "leftAcrossMissed"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          leftAcrossAvgTimeToHit: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key === "leftHand" &&
                  assessment?.property === "leftAcrossAvgTimeToHit"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          leftAcrossReachDist: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key === "leftHand" &&
                  assessment?.property === "leftAcrossReachDist"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          leftOutwardHit: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key === "leftHand" &&
                  assessment?.property === "leftOutwardHit"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          leftOutwardMissed: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key === "leftHand" &&
                  assessment?.property === "leftOutwardMissed"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          leftOutwardAvgTimeToHit: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key === "leftHand" &&
                  assessment?.property === "leftOutwardAvgTimeToHit"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          leftOutwardReachDist: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key === "leftHand" &&
                  assessment?.property === "leftOutwardReachDist"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
        },
        rightHand: {
          rightAcrossHit: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key === "rightHand" &&
                  assessment?.property === "rightAcrossHit"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          rightAcrossMissed: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key === "rightHand" &&
                  assessment?.property === "rightAcrossMissed"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          rightAcrossAvgTimeToHit: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key === "rightHand" &&
                  assessment?.property === "rightAcrossAvgTimeToHit"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          rightAcrossReachDist: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key === "rightHand" &&
                  assessment?.property === "rightAcrossReachDist"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          rightOutwardHit: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key === "rightHand" &&
                  assessment?.property === "rightOutwardHit"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          rightOutwardMissed: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key === "rightHand" &&
                  assessment?.property === "rightOutwardMissed"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          rightOutwardAvgTimeToHit: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key === "rightHand" &&
                  assessment?.property === "rightOutwardAvgTimeToHit"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          rightOutwardReachDist: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key === "rightHand" &&
                  assessment?.property === "rightOutwardReachDist"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
        },
      };
      setAssessmentSummary((prevState: Reports) => ({
        ...prevState,
        score: extractJSon as BalloonPopperScore,
      }));
    } else if (
      visitDataVirtuBalanceTests[0]?.vbTestLookupId === TestType.veggie_samurai
    ) {
      visitDataVirtuBalanceTestPhaseValuesBreakup =
        visitDataVirtuBalanceTestPhaseValuesBreakup.sort(
          (a: any, b: any) => b.phaseId - a.phaseId,
        );
      debugger;
      let extractJSon = {
        user1PlayedSeated: String(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "user1PlayedSeated") {
                return assessment;
              }
            },
          )?.value,
        ),
        score: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "score") {
                return assessment;
              }
            },
          )?.value,
        ),
        scorePerMinute: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "scorePerMinute") {
                return assessment;
              }
            },
          )?.value,
        ),
        veggiesCut: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              debugger;
              if (
                assessment?.property === "veggies_cut" &&
                assessment?.key === "veggies_cut" &&
                (assessment?.key === "veggies_cut" ||
                  assessment?.key === "rounds")
              ) {
                return assessment;
              }
            },
          )?.value,
        ),
        veggiesMissed: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "veggies_missed") {
                return assessment;
              }
            },
          )?.value,
        ),
        veggieAccuracy: visitDataVirtuBalanceTestPhaseValuesBreakup.find(
          (assessment: any) => {
            if (assessment?.property === "veggie_accuracy") {
              return assessment;
            }
          },
        )?.value,
        spongesCut: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              debugger;
              if (
                assessment?.property === "sponges_cut" &&
                (assessment?.key === "sponges_cut" ||
                  assessment?.key === "rounds")
              ) {
                return assessment;
              }
            },
          )?.value,
        ),
        spongeAccuracy: Number(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => {
              if (assessment?.property === "sponge_accuracy") {
                return assessment;
              }
            },
          )?.value,
        ),
        difficulty: {
          time: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key === "difficulty" &&
                  assessment?.property === "time"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          vegetableMoveSpeed: String(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key === "difficulty" &&
                  assessment?.property === "vegetableMoveSpeed"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          reachDifficulty: String(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key === "difficulty" &&
                  assessment?.property === "reachDifficulty"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          armMode: String(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key === "difficulty" &&
                  assessment?.property === "armMode"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
        },
        left: {
          veggiesCut: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                debugger;
                if (
                  assessment?.key.toLowerCase() === "left" &&
                  assessment?.property === "veggies_cut"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          spongesCut: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() === "left" &&
                  assessment?.property === "sponges_cut"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
        },
        right: {
          veggiesCut: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                debugger;
                if (
                  assessment?.key.toLowerCase() === "right" &&
                  assessment?.property === "veggies_cut"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          spongesCut: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() === "right" &&
                  assessment?.property === "sponges_cut"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
        },
      };
      debugger;
      setAssessmentSummary((prevState: Reports) => ({
        ...prevState,
        score: extractJSon as VeggieSlicerScore,
      }));
    } else if (visitDataVirtuBalanceTests[0]?.vbTestLookupId === TestType.tug) {
      visitDataVirtuBalanceTestPhaseValuesBreakup =
        visitDataVirtuBalanceTestPhaseValuesBreakup.sort(
          (a: any, b: any) => b.phaseId - a.phaseId,
        );
      let extractJSon = {
        startTime: String(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => assessment?.property === "start_time",
          )?.value,
        ),
        endTime: String(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => assessment?.property === "end_time",
          )?.value,
        ),
        gait: {
          fallRisk: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() === "gait" &&
                  assessment?.property === "fall_risk"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          tugSpeed: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() === "gait" &&
                  assessment?.property === "tug_speed"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          distance: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() === "gait" &&
                  assessment?.property === "distance"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          ambulationTime: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() === "gait" &&
                  assessment?.property === "ambulation_time"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          velocity: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() === "gait" &&
                  assessment?.property === "velocity"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          meanNormalizedVelocity: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() === "gait" &&
                  assessment?.property === "mean_normalized_velocity"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          numberOfSteps: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() === "gait" &&
                  assessment?.property === "number_of_steps"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          cadence: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() === "gait" &&
                  assessment?.property === "cadence"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
          usedAssistiveDevice: String(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() === "gait" &&
                  assessment?.property === "used_assistive_device"
                ) {
                  return assessment;
                }
              },
            )?.value || "",
          ),
        },
        timing: {
          totalTime: Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() === "timing" &&
                  assessment?.property === "total"
                ) {
                  return assessment;
                }
              },
            )?.value,
          ),
        },
        result: String(
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (assessment: any) => assessment?.property === "result",
          )?.value,
        ),
      };
      setAssessmentSummary((prevState: Reports) => ({
        ...prevState,
        score: extractJSon as TugScore,
      }));

      // Check if assessment is incomplete
      if (
        extractJSon.result &&
        extractJSon.result.toLowerCase() === "incomplete"
      ) {
        setmobilityLevel("low");
        setIsIncompleteAssessment(true);
      } else {
        setIsIncompleteAssessment(false);
        let mobilityCheck = 0;

        // Try to get mobility from mobilityCalculatedValue first (for app 1 or 2)
        if (
          (visitDataVirtuBalanceTests[0]?.applicationLookupId === 1 ||
            visitDataVirtuBalanceTests[0]?.applicationLookupId === 2) &&
          mobilityCalculatedValue &&
          mobilityCalculatedValue.length > 0 &&
          mobilityCalculatedValue[0]?.calculatedValue != null
        ) {
          mobilityCheck = mobilityCalculatedValue[0].calculatedValue;
        } else {
          // Fallback to timing.total calculation
          const totalTimeMs = Number(
            visitDataVirtuBalanceTestPhaseValuesBreakup.find(
              (assessment: any) => {
                if (
                  assessment?.key.toLowerCase() === "timing" &&
                  assessment?.property === "total"
                ) {
                  return assessment;
                }
              },
            )?.value,
          );
          mobilityCheck = totalTimeMs / 1000; // Convert milliseconds to seconds
        }

        console.log("TUG mobilityCheck value (seconds):", mobilityCheck);
        debugger;

        // Set mobility level based on time in seconds
        if (mobilityCheck > 14) {
          setmobilityLevel("low");
        } else if (mobilityCheck <= 14 && mobilityCheck >= 10) {
          setmobilityLevel("medium");
        } else if (mobilityCheck < 10 && mobilityCheck > 0) {
          setmobilityLevel("high");
        } else {
          // Handle invalid values (0, NaN, negative)
          console.warn("Invalid TUG mobility check value:", mobilityCheck);
          setmobilityLevel("low");
        }
      }
    } else if (
      visitDataVirtuBalanceTests[0]?.vbTestLookupId === TestType.reach
    ) {
      visitDataVirtuBalanceTestPhaseValuesBreakup =
        visitDataVirtuBalanceTestPhaseValuesBreakup.sort(
          (a: any, b: any) => a.phaseId - b.phaseId,
        );

      let extractJSon: any;

      debugger;
      // Check if applicationLookupId is 2
      if (
        visitDataVirtuBalanceTests[0]?.applicationLookupId === 1 ||
        visitDataVirtuBalanceTests[0]?.applicationLookupId === 2
      ) {
        // Extract configs for this test type
        const phases =
          virtubalancetestsconfigs
            ?.filter((config: any) => config.vbTestLookupId === TestType.reach)
            .map((h: any) => {
              // Filter matching phases
              const value =
                visitDataVirtuBalanceTestPhases?.filter(
                  (w: any) =>
                    w.phaseConfig != null && w.phaseConfig === h.index,
                ) || [];

              // Calculate phase score sum
              const phaseScoreSum =
                value.length > 0
                  ? value.reduce(
                      (sum: number, y: any) => sum + (y.phaseScore || 0),
                      0,
                    )
                  : 0;

              // Convert from meters to inches
              const convertedScore = convertUnit(
                phaseScoreSum,
                ConversionRequired.MeterToInches,
              );

              // Round the converted value
              let phaseScoreValue =
                Math.round(Number(convertedScore) * 10) / 10;

              // Average if there are multiple values
              if (value.length > 0) {
                phaseScoreValue =
                  Math.round((phaseScoreValue / value.length) * 10) / 10;
              }

              // Handle NaN
              const finalScore = isNaN(phaseScoreValue) ? 0 : phaseScoreValue;

              // Get display key from config
              let displayKey = h.displayText || h.configCode || "";
              if (displayKey.toLowerCase() === "forward") {
                displayKey = "Forward Reach";
              }

              return {
                maximum_reach: finalScore,
                maximum_reach_time: 0,
                phase_score: finalScore,
                key: displayKey,
                mode: {
                  index: h.index || 0,
                  code: h.configCode || "",
                },
              };
            }) || [];

        console.log("phases FR (applicationLookupId == 2)", phases);

        // Get start and end times
        const startTime =
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (item: any) => item.property === "start_time",
          )?.value || "";

        const endTime =
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (item: any) => item.property === "end_time",
          )?.value || "";

        // Create the functional reach object
        extractJSon = {
          id: visitDataVirtuBalanceTests[0]?.vbTestId || 0,
          test_type: "functional_Reach",
          startTime: String(startTime),
          endTime: String(endTime),
          LeftReach:
            phases.find((p: any) => p.mode.code === "left")?.maximum_reach || 0,
          RightReach:
            phases.find((p: any) => p.mode.code === "right")?.maximum_reach ||
            0,
          ForwardReach:
            phases.find((p: any) => p.mode.code === "forward")?.maximum_reach ||
            0,
          phases: phases,
        };
      } else {
        // Group data by phaseId
        const phaseGroups: any = {};
        visitDataVirtuBalanceTestPhaseValuesBreakup.forEach((item: any) => {
          if (!phaseGroups[item.phaseId]) {
            phaseGroups[item.phaseId] = [];
          }
          phaseGroups[item.phaseId].push(item);
        });

        // Extract phases data from grouped data
        const phases = Object.keys(phaseGroups).map((phaseId) => {
          const phaseData = phaseGroups[phaseId];

          // Extract values for each property
          const maxReach = phaseData.find(
            (item: any) => item.property === "maximum_reach",
          );
          const maxReachTime = phaseData.find(
            (item: any) => item.property === "maximum_reach_time",
          );
          const modeCode = phaseData.find(
            (item: any) => item.key === "mode" && item.property === "code",
          );
          const modeIndex = phaseData.find(
            (item: any) => item.key === "mode" && item.property === "index",
          );

          const maximumReachValue = Number(maxReach?.value || 0);
          const convertedReach = maximumReachValue * 39.3701;

          // Get display key from mode code
          let displayKey = modeCode?.value || "";
          if (displayKey.toLowerCase() === "forward") {
            displayKey = "Forward Reach";
          } else if (displayKey.toLowerCase() === "left") {
            displayKey = "Left Reach";
          } else if (displayKey.toLowerCase() === "right") {
            displayKey = "Right Reach";
          }

          return {
            maximum_reach: convertedReach,
            maximum_reach_time: Number(maxReachTime?.value || 0),
            phase_score: convertedReach,
            key: displayKey,
            mode: {
              index: Number(modeIndex?.value || 0),
              code: modeCode?.value || "",
            },
          };
        });

        console.log("phases FR (else case)", phases);

        // Get start and end times
        const startTime =
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (item: any) => item.property === "start_time",
          )?.value || "";

        const endTime =
          visitDataVirtuBalanceTestPhaseValuesBreakup.find(
            (item: any) => item.property === "end_time",
          )?.value || "";

        // Create the functional reach object
        extractJSon = {
          id: visitDataVirtuBalanceTests[0]?.vbTestId || 0,
          test_type: "functional_Reach",
          startTime: String(startTime),
          endTime: String(endTime),
          LeftReach:
            phases.find((p: any) => p.mode.code === "left")?.maximum_reach || 0,
          RightReach:
            phases.find((p: any) => p.mode.code === "right")?.maximum_reach ||
            0,
          ForwardReach:
            phases.find((p: any) => p.mode.code === "forward")?.maximum_reach ||
            0,
          phases: phases,
        };
      }
      debugger;
      setAssessmentSummary((prevState: Reports) => ({
        ...prevState,
        score: extractJSon as FunctionalReachScore,
      }));

      if (mobilityCalculatedValue && mobilityCalculatedValue.length > 0) {
        let mobilityCheck = mobilityCalculatedValue[0].calculatedValue;
        let mobility = mobilityCalculatedValue[0].mobility;

        console.log("mobilityCheck FR", mobilityCheck);
        // if (mobilityCheck < 6) {
        //   setmobilityLevel("low");
        // } else if (mobilityCheck <= 10 && mobilityCheck >= 6) {
        //   setmobilityLevel("medium");
        // } else if (mobilityCheck > 10) {
        //   setmobilityLevel("high");
        // }
        setmobilityLevel(mobility);
      }
    } else if (
      visitDataVirtuBalanceTests[0]?.vbTestLookupId === TestType.ctsib
    ) {
      let extractJSon = {
        Visual: Number(
          visitDataVirtuBalanceTestValues.find((assessment: any) => {
            if (assessment?.key === "visual") {
              return assessment;
            }
          })?.value,
        ),
        Vestibular: Number(
          visitDataVirtuBalanceTestValues.find((assessment: any) => {
            if (assessment?.key === "vestibular") {
              return assessment;
            }
          })?.value,
        ),
        Somatosensory: Number(
          visitDataVirtuBalanceTestValues.find((assessment: any) => {
            if (assessment?.key === "somatosensory") {
              return assessment;
            }
          })?.value,
        ),
        Composite: Number(
          visitDataVirtuBalanceTestValues.find((assessment: any) => {
            if (assessment?.key === "overall") {
              return assessment;
            }
          })?.value,
        ),
      };
      setAssessmentSummary((prevState: Reports) => ({
        ...prevState,
        score: extractJSon as MctsibScore,
      }));
      if (mobilityCalculatedValue && mobilityCalculatedValue.length > 0) {
        setmobilityLevel(mobilityCalculatedValue[0].mobility);
      }
    }
  };

  const setSetting = async () => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    console.log("current assessment: ", currentAssessment);
    await getAllComments();
    try {
      await GenerateTestsReport({
        BusinessType: 1,
        SpecificPatientId: currentAssessment?.patientId,
        SpecificTestLookupId: currentAssessment?.assessmentType
          ? currentAssessment.assessmentType
          : 0,
        SpecificMasterTestId: currentAssessment?.masterTestId,
        SpecificTestId: currentAssessment?.testId,
        SpecificWorkstationId: currentAssessment?.workstationId,
        SpecificLocationId: currentAssessment?.locationId,
        EncryptedServerId: localStorage.getItem("EncryptedServerId"),
        TestIDList: null,
        StartDate: null,
        EndDate: null,
        ComparisionCall: false,
        IsViewFullSummary: currentAssessment?.isViewFullSummary,
      }).then((res: any) => {
        if (!navigator.onLine) {
          setShowNetWorkRecoil({ isShown: true });
          return;
        }
        if (res) {
          setLoading(true);
          console.log("APi Response", res);
          setTestTime(
            res?.data?.dataStructure.visitDataVirtuBalanceTests[0]?.time,
          );
          setMasterVisitId(
            res?.data?.dataStructure.visitDataVirtuBalanceTests[0]
              ?.masterVisitId,
          );
          destrutuceReportsRspond(res?.data?.dataStructure);
          setPatientDetails(res?.data.patientInfo?.patientVM);

          console.log("rtmEnabledRef.current", rtmEnabledRef.current);
          console.log(
            "res?.data.patientInfo?.patientVM?.isPatientRTMEnabled",
            res?.data.patientInfo?.patientVM?.isPatientRTMEnabled,
          );
          console.log("isAssessmentCompleted", isAssessmentCompleted);

          if (
            !res?.data.patientInfo?.patientVM?.isPatientRTMEnabled &&
            rtmEnabledRef.current &&
            isAssessmentCompleted &&
            (!patientDetails?.isSFTPEhrImportEnabled ||
              patientDetails?.externalPatientId !== 0)
          ) {
            // setTimeout(() => {
            //   setRemoteTherapeuticMonitoring(true);
            // }, 200);
            localStorage.setItem("rtmEnabledRefOnCompletion", "true");
          } else {
            localStorage.removeItem("rtmEnabledRefOnCompletion");
          }
        }
      });
    } catch (ex: any) {
      console.log("Exception in report generation: ", ex);
    }

    setpatientAge(convertDOBintoAge(new Date(patientInfo?.dob)));
  };

  const handleFocus = (e: any) => {
    let type = e.type;
    let getParent = e.target.closest(".addComment");
    if (type == "focus") {
      getParent.classList.remove("bg-image-edit");
      getParent.nextElementSibling.classList.remove("hide");
    } else if (type == "blur") {
      getParent.classList.add("bg-image-edit");
      getParent.nextElementSibling.classList.add("hide");
    }
  };

  const postComment = async () => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    let str = note.trim();
    setNote("");
    console.log("current assessment: ", currentAssessment);

    if (str?.length) {
      debugger;
      //var testtime = testTime;
      await AddReportComments({
        testDateTime: testTime,
        testId: currentAssessment.testId,
        masterVisitId:
          currentAssessment.masterVisitId == 0
            ? masterVisitId
            : currentAssessment.masterVisitId,
        masterUserId: JSON.parse(localStorage.getItem("patientMasterID")!),
        comments: note,
        EncryptedServerId: localStorage.getItem("EncryptedServerId"),
      }).then((res: any) => {
        if (!navigator.onLine) {
          setShowNetWorkRecoil({ isShown: true });
          return;
        }
        if (res?.data?.isResponseSuccessfull) {
          // console.log("comments response", res)
          getAllComments();
        }
      });
    } else {
      setNote("");
    }
  };
  const [mobilityLevel, setmobilityLevel] = useState("");
  const [isIncompleteAssessment, setIsIncompleteAssessment] = useState(false);

  const getNoteText = (e: any) => {
    setNote(e.detail.value);
  };

  const dummyJson: any = {
    test_type: "red_light_green_light",
    score: {
      average_speed: 0.68,
      distance: 35,
      red_lights_missed: 12,
      meters_lost: 41,
      fall_risk: 65,
      gait_speed: 0.68,
      ambulation_time: 1200,
      velocity: 139.38,
      mean_normlized_velocity: 175.18,
      number_of_steps: 6,
      cadence: 130,
      left: {
        step_length: 0.4004,
      },
      right: {
        step_length: 0.569,
      },
    },
    used_assistive_device: "False",
    start_time: "16738499806",
    end_time: "1673850008",
  };

  const calculatefallRisk = (score: GaitScore) => {
    let fallrisk;
    if (score.fallRisk == null || score.fallRisk === 0) {
      fallrisk = Math.round(
        GetGaitFallRisk(
          convertUnit(score.gaitSpeed, ConversionRequired.MeterToCentiMeter),
        ),
      );
    } else {
      fallrisk = Math.round(score.fallRisk);
    }
    return fallrisk;
  };

  const getNormMeanAndSTDForVelocity = (age: number): [number, number] => {
    if (age >= 6 && age <= 12) return [1.13, 0.15];
    if (age >= 13 && age <= 19) return [1.22, 0.15];
    if (age >= 20 && age <= 64) return [1.32, 0.16];
    if (age >= 65 && age <= 69) return [1.32, 0.16];
    if (age >= 70 && age <= 74) return [1.16, 0.2];
    if (age >= 75 && age <= 79) return [1.12, 0.17];
    if (age >= 80 && age <= 84) return [1.01, 0.15];
    if (age >= 85) return [0.98, 0.2];

    return [1.13, 0.15]; // Default case if no conditions are met
  };

  const calculateBelowAboveNorm = (
    gaitValue: number,
    mean: number,
    stddev: number,
  ): number => {
    return (gaitValue - mean) / stddev;
  };

  const round = (value: number, decimals: number): number => {
    const factor = Math.pow(10, decimals);
    return Math.round(value * factor) / factor;
  };

  function getUpToDecimal(number: number, decimalPlaces: number) {
    const factor = Math.pow(10, decimalPlaces);
    return Math.trunc(number * factor) / factor;
  }

  const calculatePercentile = (
    gaitValue: number,
    mean: number,
    stddev: number,
  ): string => {
    var diff = gaitValue - round(mean, 2);
    let gaitpercentile = diff / stddev;
    let sGaitPercential = "";
    const gt = new GaitPercentialTable();
    console.log("gaitPercentile:", gaitpercentile);

    if (gaitpercentile >= 0) {
      let i = gt.PFirstValue.indexOf(getUpToDecimal(gaitpercentile, 1));
      let j = gt.PSecondValue.indexOf(
        Math.abs(
          getUpToDecimal(gaitpercentile - getUpToDecimal(gaitpercentile, 1), 2),
        ),
      );
      if (j === 0) j++;
      if (i === 0) i++;
      if (i > -1 && j > -1) {
        gaitpercentile = gt.PositiveZ[i][j] * 100.0;
        sGaitPercential = round(Math.abs(gaitpercentile), 2).toString();
      } else {
        gaitpercentile = 99.9;
        sGaitPercential = "99.9";
      }
    } else {
      let i = gt.NFirstValue.indexOf(getUpToDecimal(gaitpercentile, 1));
      let j = gt.NSecondValue.indexOf(
        Math.abs(
          getUpToDecimal(gaitpercentile - getUpToDecimal(gaitpercentile, 1), 2),
        ),
      );
      if (j === 0) j++;
      if (i === 0) i++;
      if (
        i >= 0 &&
        i < gt.NegativeZ.length &&
        j >= 0 &&
        j < gt.NegativeZ[i]?.length
      ) {
        gaitpercentile = gt.NegativeZ[i][j] * 100.0;
        sGaitPercential = round(Math.abs(gaitpercentile), 2).toString();
      }
      if (i > -1 && j > -1) {
        gaitpercentile = gt.NegativeZ[i][j] * 100.0;
        console.log("gaitpercentile", gaitpercentile);

        sGaitPercential = round(Math.abs(gaitpercentile), 2).toString();

        console.log("i", i, "j", j, "gaitpercentile", gaitpercentile);
      } else {
        gaitpercentile = 0.01;
        sGaitPercential = "0.01";
      }
    }
    return sGaitPercential;
  };

  const colorModes = {
    green: "#43BA73",
    orange: "#F8993A",
    red: "#DB4B4B",
    blue: "#6F86F8",
    yellow: "#F8993A",
  };

  const getFallRiskColor = (value: GaitScore) => {
    if (value.gaitSpeed < 0.4) {
      return colorModes.red;
    } else if (value.gaitSpeed >= 0.4 && value.gaitSpeed < 0.7) {
      return colorModes.red;
    } else if (value.gaitSpeed >= 0.7 && value.gaitSpeed <= 1.07) {
      return colorModes.orange;
    } else if (value.gaitSpeed > 1.07) {
      return colorModes.green;
    }
  };

  const redirectBackToPatientPage = () => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }

    let storedValue = localStorage.getItem("rtmEnabledRefOnCompletion");

    if (
      !patientDetails?.isPatientRTMEnabled &&
      storedValue &&
      rtmEnabledRef.current &&
      isAssessmentCompleted &&
      (!patientDetails?.isSFTPEhrImportEnabled ||
        patientDetails?.externalPatientId !== 0)
    ) {
      localStorage.setItem("rtmEnabledRefOnCompletion", "true");
      window.dispatchEvent(new Event("showRtmPopupOnCompletion"));
    } else {
      localStorage.removeItem("rtmEnabledRefOnCompletion");
      history.push("/patient-page");
    }
  };

  const redirectBackToExercisePage = () => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }

    let storedValue = localStorage.getItem("rtmEnabledRefOnCompletion");

    debugger;
    if (
      !patientDetails?.isPatientRTMEnabled &&
      storedValue &&
      rtmEnabledRef.current &&
      isAssessmentCompleted &&
      (!patientDetails?.isSFTPEhrImportEnabled ||
        patientDetails?.externalPatientId !== 0)
    ) {
      localStorage.setItem("rtmEnabledRefOnCompletion", "true");
      window.dispatchEvent(new Event("showRtmPopupOnCompletion"));
    } else {
      localStorage.removeItem("rtmEnabledRefOnCompletion");
      history.push("/full-visit-summary", {
        patientInfo: patientDetails,
      });
    }
  };

  const [GraphAsseDesc, setGraphAsseDesc] = useState(false);
  const [modalData, setModalData] = useState<any>({}); // Initialize modalData
  const handleOpenModal = () => {
    setModalData(createModalData()); // Set modal data when opening modal
    setGraphAsseDesc(true);
  };

  const getGaitMobility = () => {
    let description: JSX.Element = <></>;
    let measurementDescription: JSX.Element = <></>;

    const [mean, stddev] = getNormMeanAndSTDForVelocity(patientAge);
    const belowAboveNorm = calculateBelowAboveNorm(
      (assessmentSummary.score as GaitScore).gaitSpeed,
      mean,
      stddev,
    );
    const belowOrAbove = belowAboveNorm < 0 ? "below" : "above";
    const stdDeviation = round(Math.abs(belowAboveNorm), 1);
    const fallRiskPercent = calculatefallRisk(
      assessmentSummary.score as GaitScore,
    );
    const sGaitPercentile = calculatePercentile(
      (assessmentSummary.score as GaitScore).gaitSpeed,
      mean,
      stddev,
    );

    if (patientAge >= 85) {
      description = (
        <>
          The individual is at {fallRiskPercent}%<sup>3</sup> risk of fall in
          the next 12 months and is a {mobilityLevel} mobility based on their
          performed gait speed.
        </>
      );
      measurementDescription = (
        <>
          The individual performed at {stdDeviation} standard deviations
          <sup>2</sup> {belowOrAbove} the mean gait speed for age range 85+ and
          is in the {sGaitPercentile} percentile for this population.
        </>
      );
    } else if (patientAge >= 80 && patientAge <= 84) {
      description = (
        <>
          The individual is at {fallRiskPercent}%<sup>3</sup> risk of fall in
          the next 12 months and is a {mobilityLevel} mobility based on their
          performed gait speed.
        </>
      );
      measurementDescription = (
        <>
          The individual performed at {stdDeviation}
          standard deviations<sup>2</sup> {belowOrAbove} the mean gait speed for
          age range 80-84 and is in the {sGaitPercentile} percentile for this
          population.
        </>
      );
    } else if (patientAge >= 75 && patientAge <= 79) {
      description = (
        <>
          The individual is at {fallRiskPercent}%<sup>3</sup> risk of fall in
          the next 12 months and is a {mobilityLevel} mobility based on their
          performed gait speed.
        </>
      );
      measurementDescription = (
        <>
          The individual performed at {stdDeviation}
          standard deviations<sup>2</sup> {belowOrAbove} the mean gait speed for
          age range 75-79 and is in the {sGaitPercentile} percentile for this
          population.
        </>
      );
    } else if (patientAge >= 70 && patientAge <= 74) {
      description = (
        <>
          The individual is at {fallRiskPercent}%<sup>2</sup> risk of fall in
          the next 12 months and is a {mobilityLevel} mobility based on their
          performed gait speed.
        </>
      );
      measurementDescription = (
        <>
          The individual performed at {stdDeviation} standard deviations
          <sup>2</sup> {belowOrAbove} the mean gait speed for age range 70-74
          and is in the {sGaitPercentile} percentile for this population.
        </>
      );
    } else if (patientAge >= 65 && patientAge <= 69) {
      description = (
        <>
          The individual is a {mobilityLevel} mobility based on their performed
          gait speed.
        </>
      );
      measurementDescription = (
        <>
          The individual performed at {stdDeviation} standard deviations
          <sup>2</sup> {belowOrAbove} the mean gait speed for age range 65-69
          and is in the {sGaitPercentile} percentile for this population.
        </>
      );
    } else if (patientAge < 65) {
      description = (
        <>
          The individual is a {mobilityLevel} mobility based on their performed
          gait speed.
        </>
      );
      measurementDescription = (
        <>
          The individual performed at {stdDeviation} standard deviations
          <sup>2</sup> {belowOrAbove} the mean gait speed for age range &lt;65
          and is in the {sGaitPercentile} percentile for this population.
        </>
      );
    }

    return { description, measurementDescription };
  };

  const createModalData = () => {
    const { description, measurementDescription } = getGaitMobility();
    let data = {
      setGraphAsseDesc: setGraphAsseDesc,
      title: "Overall Mobility",
      icon: (
        <svg
          width="54"
          height="84"
          viewBox="0 0 54 84"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.1167 7.875C19.1167 5.78642 19.9464 3.78338 21.4232 2.30653C22.9001 0.829685 24.9031 0 26.9917 0C29.0803 0 31.0833 0.829685 32.5602 2.30653C34.037 3.78338 34.8667 5.78642 34.8667 7.875C34.8667 9.96358 34.037 11.9666 32.5602 13.4435C31.0833 14.9203 29.0803 15.75 26.9917 15.75C24.9031 15.75 22.9001 14.9203 21.4232 13.4435C19.9464 11.9666 19.1167 9.96358 19.1167 7.875ZM25.6792 57.75V78.75C25.6792 81.6539 23.3331 84 20.4292 84C17.5253 84 15.1792 81.6539 15.1792 78.75V42.1477L10.487 49.957C8.99404 52.4344 5.76201 53.2383 3.28467 51.7453C0.807322 50.2523 0.00341582 47.0203 1.49638 44.543L11.0612 28.6289C13.9159 23.8875 19.0347 20.9836 24.5636 20.9836H29.4362C34.9651 20.9836 40.0839 23.8875 42.9386 28.6289L52.5034 44.543C53.9964 47.0203 53.1925 50.2523 50.7151 51.7453C48.2378 53.2383 45.0058 52.4344 43.5128 49.957L38.8042 42.1477V78.75C38.8042 81.6539 36.4581 84 33.5542 84C30.6503 84 28.3042 81.6539 28.3042 78.75V57.75H25.6792Z"
            fill="black"
          />
        </svg>
      ),
      unit: "",
      description: description,
      measurementDescription: measurementDescription,
      measurementsList: [] as string[],
    };

    return data; // Return the populated modal data
  };

  console.log("Assesment Sumaryy 123", assessmentSummary);
  console.log("assessmentTestType", assessmentTestType);

  const enableDisablePatientRtm = async (
    isNewEpisode: boolean,
    isRtmReenable: boolean,
  ) => {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    try {
      await EnableDisablePatientRtm({
        PatientId: localStorage.getItem("patientServerID"),
        EncryptedServerId: localStorage.getItem("EncryptedServerId"),
        IsPatientRTMEnabled: !patientDetails?.isPatientRTMEnabled,
        LocalDateTime: localDateTime(),
        IsNewEpisode: isNewEpisode,
        IsRtmReenable: isRtmReenable,
        MasterUserId: JSON.parse(localStorage.getItem("patientMasterID")!),
        MobilePhone: localStorage.getItem("patientMobileNumber") ?? "",
      }).then(async function (response: any) {
        console.log("Response: ", response);
        if (response?.data?.dbResponse?.id > 0) {
          let status;
          if (!patientDetails?.isPatientRTMEnabled) {
            status = "true";
          } else {
            status = "false";
          }
          sessionStorage.setItem("isPatientRtmTrue", status);
          sessionStorage.setItem(
            "patientDetails",
            JSON.stringify(patientDetails),
          );
          handleEducationClose();
        }
      });
    } catch (error) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  };

  //RTM Toggle
  const handleRtmToggle = async () => {
    console.log(
      "patientDetails?.isPatientRTMEnabled",
      patientDetails?.isPatientRTMEnabled,
    );
    if (patientDetails?.isPatientRTMEnabled) {
      setRemoteTherapeuticMonitoring(true);
    } else {
      console.log(
        "patientDetails?.isRtmEverEnabled",
        patientDetails?.isRtmEverEnabled,
      );
      if (patientDetails?.isRtmEverEnabled) {
        setIsRtmReenable(true);
        setChooseEpisode(true);
        //await enableDisablePatientRtm();
      } else {
        setIsRtmReenable(false);
        setConsentForm(true);
      }
    }
  };

  const handleConsentClose = async () => {
    setConsentForm(false);
    await enableDisablePatientRtm(true, false);
    const isSFTPPatient =
      localStorage.getItem("isSFTPPatient") === "true" ? true : false;
    if (isSFTPPatient || true) {
      handleEducationClose();
    } else {
      setCompletedEducation(true);
    }
  };

  const handleConsentFormObject = (data: any) => {
    console.log("Received from ConsentFormModal:", data);
    setIsNewEpisode(true);
    setConsentFormData(data);
    setConsentForm(false);
    setSetupEpisode(true);
    // Open the SetupEpisode modal immediately
    //Setting recoil state
    setPatientDetails((prevState: any) => ({
      ...prevState,
      email: data?.Email,
      mobilePhone: data?.MobilePhone,
    }));
    console.log(
      "Updated patient details with consent form data",
      patientDetails,
    );
  };

  const handleSetupEpisodeClose = async () => {
    await enableDisablePatientRtm(true, false);
    handleEducationClose();
  };

  const handleChooseEpisodeClose = async () => {
    setIsNewEpisode(false);
    setChooseEpisode(false);
    await enableDisablePatientRtm(false, true);
    handleEducationClose();
  };

  const handleNewEpisodeClose = async () => {
    setIsNewEpisode(true);
    setNewEpisode(false);
    await enableDisablePatientRtm(true, true);
    handleEducationClose();
  };

  const handleEducationClose = () => {
    setCompletedEducation(false);
    setRtmEnabled(true);
    setOpenRtmModal(true);
  };

  const handleDisableConsentClose = () => {
    setRemoteTherapeuticMonitoring(false);
    setRtmEnabled(false);
    setOpenRtmModal(true);
  };

  const handleEnableDisableModalClose = (isEnabled: boolean) => {
    setOpenRtmModal(false);
    if (!isEnabled) {
      setPatientDetails((prevState: PatientVM) => ({
        ...prevState,
        isPatientRTMEnabled: false,
      }));
      setPatientDetailsRecoil((prevState: PatientVM) => ({
        ...prevState,
        isPatientRTMEnabled: false,
      }));
    } else {
      setPatientDetails((prevState: PatientVM) => ({
        ...prevState,
        isPatientRTMEnabled: true,
        isRtmEverEnabled: true,
      }));
      setPatientDetailsRecoil((prevState: PatientVM) => ({
        ...prevState,
        isPatientRTMEnabled: true,
        isRtmEverEnabled: true,
      }));
      history.push("/full-visit-summary", {
        patientInfo: patientDetails,
      });
    }
  };

  const handleEnableConsentClose = () => {
    setRemoteTherapeuticMonitoring(false);
    handleRtmToggle();
  };

  const handleSkipExercisePlan = (isEnabled: boolean) => {
    console.log("Skip clicked");
    setOpenRtmModal(false);
    setOpenProactiveAfterClose(true); // ONLY set when skip is clicked
    localStorage.removeItem("exercisePlan");
  };

  const handleRegisterPatient = () => {
    debugger;
    console.log("Register Patient clicked");
    setProactiveYouModal(false);
    setRegisterPatientModal(true);
  };

  const handleCloseRegistrationModal = async () => {
    setRegisterPatientModal(false);

    // Refresh patient details to get updated RTM status
    // await GetPatientVisitDetails();
  };

  useEffect(() => {
    setPatientDetails(patientDetailsRecoil);
  }, [patientDetailsRecoil]);

  return (
    <IonPage placeholder={undefined}>
      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={RemoteTherapeuticMonitoring}
        placeholder={undefined}
      >
        <RemoteTherapeuticMonitoringModal
          setRemoteTherapeuticMonitoring={setRemoteTherapeuticMonitoring}
          patientName={
            patientDetails?.firstName + " " + patientDetails?.lastName
          }
          onClose={handleDisableConsentClose}
          isDisabled={!patientDetails?.isPatientRTMEnabled}
          onEnableClick={handleEnableConsentClose}
        ></RemoteTherapeuticMonitoringModal>
      </IonModal>

      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={openRtmModal}
        placeholder={undefined}
        onDidDismiss={() => {
          if (openProactiveAfterClose) {
            console.log("Opening ProactiveYou modal now...");
            setProactiveYouModal(true);
            setOpenProactiveAfterClose(false); // reset flag
          }
        }}
      >
        <RtmEnabledModal
          enabled={RtmEnabled}
          onClose={handleEnableDisableModalClose}
          onSkip={handleSkipExercisePlan}
        ></RtmEnabledModal>
      </IonModal>

      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={registerPatientModal}
        placeholder={undefined}
      >
        <PatientRegistrationQRModal
          setRegisterPatientModal={handleCloseRegistrationModal}
          patientData={{
            masterPatientId: Number(localStorage.getItem("masterUserId")) || 0,
            email: patientDetails?.email,
            mobilePhone: patientDetails?.mobilePhone,
            firstName: patientDetails?.firstName,
            lastName: patientDetails?.lastName,
            fullName:
              patientDetails?.firstName + " " + patientDetails?.lastName,
            patientName:
              patientDetails?.firstName + " " + patientDetails?.lastName,
            dob: patientDetails?.dob,
            DOB: patientDetails?.dob,
            FirstName: patientDetails?.firstName,
            LastName: patientDetails?.lastName,
            PatientLocationId: patientDetails?.patientLocationId,
          }}
          isCalledAfterRtmEnabled={true}
          onError={(message) => {
            setErrorMessage(message);
          }}
        />
      </IonModal>

      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={proactiveYouModal}
        placeholder={undefined}
      >
        <ProactiveYouModal
          HideProactiveModal={setProactiveYouModal}
          onRegisterPatient={handleRegisterPatient}
        />
      </IonModal>

      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={CompletedEducation}
        placeholder={undefined}
      >
        <CompletedEducationModal
          setCompletedEducation={setCompletedEducation}
          patientName={
            patientDetails?.firstName + " " + patientDetails?.lastName
          }
          onClose={handleEducationClose}
        ></CompletedEducationModal>
      </IonModal>

      <IonModal
        backdropDismiss={false}
        className="consent-form-modal-wrap"
        isOpen={ConsentForm}
        placeholder={undefined}
      >
        <ConsentFormModal
          setConsentForm={setConsentForm}
          patientName={
            patientDetails?.firstName + " " + patientDetails?.lastName
          }
          phoneNumber={patientDetails?.mobilePhone ?? ""}
          email={patientDetails?.email ?? ""}
          onClose={handleConsentClose}
          consentFormObjectPassToParent={handleConsentFormObject}
        ></ConsentFormModal>
      </IonModal>
      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={SetupEpisode}
        placeholder={undefined}
      >
        <SetupEpisodeModal
          setSetupEpisode={setSetupEpisode}
          consentFormData={consentFormData}
          onClose={handleSetupEpisodeClose}
          rtmStartDate={
            consentFormData?.StartDate
              ? new Date(consentFormData.StartDate).toLocaleDateString("en-US")
              : undefined
          }
        ></SetupEpisodeModal>
      </IonModal>

      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        isOpen={NewEpisode}
        placeholder={undefined}
      >
        <NewEpisodeModal
          setNewEpisode={setNewEpisode}
          onClose={handleNewEpisodeClose}
          rtmStartDate={
            patientDetails?.rtmStartDate
              ? format(new Date(patientDetails.rtmStartDate), "MM/dd/yyyy")
              : undefined
          }
        ></NewEpisodeModal>
      </IonModal>

      <IonModal
        className="generic-modal-96-vw"
        backdropDismiss={false}
        onDidDismiss={() => setChooseEpisode(false)}
        isOpen={ChooseEpisode}
        placeholder={undefined}
      >
        <ChooseEpisodeModal
          setChooseEpisode={setChooseEpisode}
          setNewEpisode={setNewEpisode}
          onClose={handleChooseEpisodeClose}
          isOpen={ChooseEpisode}
          rtmStartDate={
            patientDetails?.rtmStartDate
              ? format(new Date(patientDetails.rtmStartDate), "MM/dd/yyyy")
              : undefined
          }
        ></ChooseEpisodeModal>
      </IonModal>
      <IonModal
        className="assessment-tape-modal-wrap"
        backdropDismiss={false}
        isOpen={measuringModal}
        placeholder={undefined}
      >
        <MeasuringTape setShowModal={setShowModal}></MeasuringTape>
      </IonModal>
      <IonModal
        className="graph-assessment-description-modal-wrap"
        backdropDismiss={false}
        placeholder={undefined}
        isOpen={GraphAsseDesc}
      >
        <GraphAssessmentDescriptionModal
          {...modalData}
        ></GraphAssessmentDescriptionModal>
      </IonModal>
      <IonHeader className="ion-no-border" placeholder={undefined}>
        <TopLeftUserName headerText={"Full Visit Summary"}></TopLeftUserName>
      </IonHeader>
      <IonContent placeholder={undefined} className="slide-in-right">
        {loading ? (
          <IonGrid
            className="container report-page  top-spacing"
            placeholder={undefined}
          >
            {/* <IonRow className="row">
            <IonCol className="col-sec">
              <div className="main-heading">
                <h1>Gait Analysis Report</h1>
              </div>
            </IonCol>
          </IonRow> */}
            <IonRow className="row" placeholder={undefined}>
              <IonCol className="col-sec" placeholder={undefined}>
                {errorMessage && <ErrorTopToaster errorString={errorMessage} />}
                <PatientSummaryInfo
                  patientDetails={patientDetails}
                  assessmentSummary={assessmentSummary}
                />
              </IonCol>
            </IonRow>
            {assessmentTestType !== TestType.upper_body_arom &&
              assessmentTestType !== TestType.hec_training &&
              assessmentTestType !== TestType.veggie_samurai &&
              !isTraining && (
                <IonRow className="row" placeholder={undefined}>
                  <IonCol className="col-sec" placeholder={undefined}>
                    <div className="report-mobility-sec">
                      <div className="mobility-level">
                        <h2>Mobility Level</h2>
                      </div>
                      <div
                        className={`mobility-bar-wrap ${
                          // mobilityLevel == "ultraLow" ||
                          mobilityLevel == "low"
                            ? "low"
                            : mobilityLevel == "medium"
                              ? "medium"
                              : "high"
                        }`}
                      >
                        <h3>
                          {mobilityLevel ? mobilityLevel.toUpperCase() : ""}
                          {isIncompleteAssessment &&
                            assessmentTestType === TestType.tug &&
                            " (Incomplete assessment)"}
                        </h3>
                        {/* <div className="mobility-bar">
                        <span></span>
                      </div> */}
                        {patientDetails &&
                          Number(patientDetails?.age) > 70 &&
                          assessmentTestType === TestType.gait && (
                            <div
                              className="circle-data"
                              style={{
                                backgroundColor: getFallRiskColor(
                                  assessmentSummary.score as GaitScore,
                                ),
                              }}
                            >
                              <h3 className="less-70">
                                {calculatefallRisk(
                                  assessmentSummary.score as GaitScore,
                                ) + "%"}
                              </h3>
                            </div>
                          )}
                      </div>
                    </div>
                  </IonCol>
                </IonRow>
              )}
            <div style={{ paddingTop: "25px" }} className="main-graph-wrap">
              <TestWrapper
                score={assessmentSummary.score}
                testType={assessmentTestType}
              />
              {(assessmentSummary.score as GaitScore) && (
                // assessmentSummary != undefined &&
                // // && assessmentSummary?.score?.fallRisk &&
                // (assessmentSummary.score as GaitScore).fallRisk != 0 && !isNaN(assessmentSummary?.score?.fallRisk) &&
                // // <CustomGraph graph={"FallRisk"} range={patientAge} value1={assessmentSummary.score.fallRisk} value2={0} />
                // <CustomGraph graph={"FallRisk"} range={patientAge} value1={assessmentSummary.score.fallRisk} value2={0} />
                <>
                  {/* {assessmentSummary != undefined && !isNaN(assessmentSummary?.score?.gaitSpeed) && assessmentSummary?.score?.gaitSpeed && assessmentSummary?.score?.gaitSpeed != 0 &&
                    <CustomGraph graph={"GaitSpeed"} range={patientAge} value1={assessmentSummary.score.gaitSpeed} value2={0} />
                  }
                  {assessmentSummary != undefined && !isNaN(assessmentSummary?.score?.left.stepLength) && !isNaN(assessmentSummary?.score?.right.stepLength) && assessmentSummary?.score?.left && assessmentSummary?.score?.right && assessmentSummary?.score?.left.stepLength != 0 && assessmentSummary?.score?.right.stepLength != 0 &&
                    <CustomGraph graph={"StepsLength"} range={patientAge} value1={assessmentSummary.score.left.stepLength} value2={assessmentSummary.score.right.stepLength} />
                  }
                  {assessmentSummary != undefined && !isNaN(assessmentSummary?.score?.numberOfSteps) && assessmentSummary?.score?.numberOfSteps && assessmentSummary?.score?.numberOfSteps != 0 &&
                    <CustomGraph graph={"NumbersOfSteps"} range={patientAge} value1={assessmentSummary.score.numberOfSteps} value2={0} />
                  }
                  {assessmentSummary != undefined && !isNaN(assessmentSummary?.score?.numberOfSteps) && assessmentSummary?.score?.numberOfSteps && assessmentSummary?.score?.numberOfSteps != 0 &&
                    <CustomGraph graph={"TotalTime"} range={patientAge} value1={assessmentSummary.score.numberOfSteps} value2={0} />
                  }
                  {assessmentSummary != undefined && !isNaN(assessmentSummary?.score?.numberOfSteps) && assessmentSummary?.score?.numberOfSteps && assessmentSummary?.score?.numberOfSteps != 0 &&
                    <CustomGraph graph={"NumbersOfSteps"} range={patientAge} value1={assessmentSummary.score.numberOfSteps} value2={0} />
                  } */}
                </>
              )}

              {/* {assessmentSummary != undefined && (assessmentSummary?.score as GaitScore)?.fallRisk != 0 && !isNaN((assessmentSummary?.score as GaitScore)?.fallRisk) &&
                  <CustomGraph graph={"FallRisk"} range={patientAge} value1={(assessmentSummary?.score as GaitScore)?.fallRisk} value2={0} />
                  } */}
              {/* updated code Fall Risk Graph */}
              {/* {assessmentSummary != undefined && (assessmentSummary?.score as GaitScore)?.fallRisk != 0 && !isNaN((assessmentSummary?.score as GaitScore)?.fallRisk) &&
                    <CustomBarGraph graphName={"FallRisk"} graphSVG={""} graphTitle={"Fall Risk"} graphTitleDesc={""} graphNormValue={0} graphActualValue={[(assessmentSummary?.score as GaitScore)?.fallRisk]} graphActualValueLabel={[`${(assessmentSummary?.score as GaitScore)?.fallRisk}%`]} graphRange={[40, 51.2]} graphRangeLabel={["40%", "51.2%"]} graphNoLines={[]} minMax={true} graphUnit={""} graphAge={12} />
                  } */}

              {/* {assessmentSummary != undefined && !isNaN((assessmentSummary?.score as GaitScore)?.gaitSpeed) && (assessmentSummary?.score as GaitScore)?.gaitSpeed && (assessmentSummary?.score as GaitScore)?.gaitSpeed != 0 &&
                    <CustomGraph graph={"GaitSpeed"} range={patientAge} value1={(assessmentSummary?.score as GaitScore)?.gaitSpeed} value2={0} />
                  }
                  {assessmentSummary != undefined && !isNaN((assessmentSummary?.score as GaitScore)?.gaitSpeed) && (assessmentSummary?.score as GaitScore)?.gaitSpeed && (assessmentSummary?.score as GaitScore)?.gaitSpeed != 0 &&
                    <GraphComponent graphName={"GaitSpeed"} graphSVG={""} graphTitle={"Gait Speed"} graphTitleDesc={"(m/s)"} graphNormValue={0} graphActualValue={[]} graphRange={[]} graphNoLines={[]} minMax={true} graphUnit={""} />
                    <GraphComponent graphName={"FallRisk"} graphSVG={""} graphTitle={"Fall Risk"} graphTitleDesc={""} graphNormValue={0} graphActualValue={[(assessmentSummary?.score as GaitScore)?.fallRisk]} graphActualValueLabel={[`${(assessmentSummary?.score as GaitScore)?.fallRisk}%`]} graphRange={[40, 51.2]} graphRangeLabel={["40%", "51.2%"]} graphNoLines={[]} minMax={true} graphUnit={""} graphAge={12} />

                  } */}

              {/* 
                  {assessmentSummary != undefined && !isNaN(assessmentSummary?.score?.left.stepLength) && !isNaN(assesmentSummary?.score?.right.stepLength) && assessmentSummary?.score?.left && assessmentSummary?.score?.right && assessmentSummary?.score?.left.stepLength != 0 && assessmentSummary?.score?.right.stepLength != 0 &&
                    <GraphComponent graphName={"StepsLength"} graphSVG={""} graphTitle={"Step Length"} graphTitleDesc={""} graphNormValue={0} graphActualValue={[]} graphRange={[]} graphNoLines={[]} minMax={true} graphUnit={""} />
                  }s
                  {assessmentSummary != undefined && !isNaN(assessmentSummary?.score?.numberOfSteps) && assessmentSummary?.score?.numberOfSteps && assessmentSummary?.score?.numberOfSteps != 0 &&
                    <GraphComponent graphName={"NumbersOfSteps"} graphSVG={""} graphTitle={"Number of Steps"} graphTitleDesc={""} graphNormValue={0} graphActualValue={[]} graphRange={[]} graphNoLines={[]} minMax={true} graphUnit={""} />
                  }
                  {assessmentSummary != undefined && !isNaN(assessmentSummary?.score?.numberOfSteps) && assessmentSummary?.score?.numberOfSteps && assessmentSummary?.score?.numberOfSteps != 0 &&
                    <GraphComponent graphName={"TotalTime"} graphSVG={""} graphTitle={"Total Time"} graphTitleDesc={""} graphNormValue={0} graphActualValue={[]} graphRange={[]} graphNoLines={[]} minMax={true} graphUnit={""} />
                  }
                  {assessmentSummary != undefined && !isNaN(assessmentSummary?.score?.numberOfSteps) && assessmentSummary?.score?.numberOfSteps && assessmentSummary?.score?.numberOfSteps != 0 &&
                    <GraphComponent graphName={"TimePerRep"} graphSVG={""} graphTitle={"Time Per Rep"} graphTitleDesc={""} graphNormValue={0} graphActualValue={[]} graphRange={[]} graphNoLines={[]} minMax={true} graphUnit={""} />
                  } */}
            </div>
            <div className="assement-notes-card-main-wrap">
              <IonLabel className="label" placeholder={undefined}>
                {isTraining ? "Training Notes" : "Assessment Notes"}
              </IonLabel>

              <div className="assement-notes-card notes-margin-bottom">
                {allComments?.map((comment: any) => {
                  return (
                    <div className="notes-description">
                      <div className="assement-note-flex">
                        <h3 className="name">
                          {" "}
                          {comment?.therapistFirstName}{" "}
                          {comment.therapistLastName}
                        </h3>
                        <h3 className="date">
                          {formateDateNotes(new Date(comment?.commentsDate))}
                        </h3>
                      </div>
                      <div className="textarea-div">
                        <p>{comment?.comments}</p>
                      </div>
                      <div className="borderBottom"></div>
                    </div>
                  );
                })}
                {/*                     
                    <div className="notes-description">
                      <div className="assement-note-flex">
                        <h3 className="name"> {assessmentSummary?.score.therapistFirstname} {assessmentSummary?.score.therapistLastName}</h3>
                        <h3 className="date">{formateDateNotes(new Date(assessmentSummary?.score?.time))}</h3>
                      </div>
                      <div className="textarea-div">
                        <p>{assessmentSummary ? assessmentSummary.note : ""}</p>
                      </div>
                      <div className="borderBottom"></div>
                    </div> */}
                {allComments?.length < 10 ? (
                  <div
                    className={`saveImage-position ${
                      note?.length ? "" : "bg-image-edit"
                    }`}
                  >
                    <IonTextarea
                      rows={1}
                      autoGrow={true}
                      className="addComment textarea-padding"
                      value={note ? note : ""}
                      placeholder="Add a comment..."
                      onIonChange={(e) => {
                        getNoteText(e);
                      }}
                    ></IonTextarea>
                    <div className="editIcon">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.44851 23.6109H0.388916V17.5513L12.6019 5.33832L18.6615 11.3979L6.44851 23.6109Z"
                          fill="#31344E"
                        />
                        <path
                          d="M20.6257 9.43373L23.5561 6.5033C24.1477 5.91169 24.1477 4.95251 23.5561 4.36091L19.6389 0.443703C19.0473 -0.147901 18.0881 -0.147901 17.4965 0.443703L14.5661 3.37414L20.6257 9.43373Z"
                          fill="#31344E"
                        />
                      </svg>
                    </div>
                    <div
                      className={`saveImage-icon ${
                        note?.length ? "" : "hide"
                      } `}
                      onClick={postComment}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                      >
                        <path
                          d="M15 29C22.732 29 29 22.732 29 15C29 7.26801 22.732 1 15 1C7.26801 1 1 7.26801 1 15C1 22.732 7.26801 29 15 29Z"
                          fill="#802392"
                          stroke="#802392"
                          strokeWidth="2"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M22 10.625L12.6667 20.25L8 15.4375"
                          stroke="white"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                ) : (
                  <p>
                    <b>You have exceeded the comments limit of 10</b>
                  </p>
                )}
              </div>
            </div>

            {!isTraining && assessmentTestType !== TestType.hec_training && (
              <>
                <div className="assement-notes-card key-card">
                  <div className="column-wrap d-flex">
                    {(assessmentTestType === TestType.five_x_sit_stand ||
                      assessmentTestType === TestType.gait ||
                      assessmentTestType === TestType.reach ||
                      assessmentTestType === TestType.tug ||
                      assessmentTestType === TestType.ctsib) && (
                      <div className="col-1">
                        <div className="target-accepted d-flex flex-column justify-content-center align-items-center">
                          <div className="dashed-line"></div>
                          <h3>Age Based Normative Value</h3>
                        </div>
                      </div>
                    )}
                    <div className="col-2">
                      <div className="d-flex justify-content-center p-relative">
                        <h4 className="key-label">Key</h4>
                        {assessmentTestType === TestType.gait && (
                          <div
                            className="exclamation-icon-graph"
                            onClick={handleOpenModal}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="26"
                              height="26"
                              viewBox="0 0 26 26"
                              fill="none"
                            >
                              <path
                                d="M14.4486 11.9198C14.4486 11.1945 13.8606 10.6065 13.1353 10.6065C12.41 10.6065 11.822 11.1945 11.822 11.9198V17.9865C11.822 18.7118 12.41 19.2998 13.1353 19.2998C13.8606 19.2998 14.4486 18.7118 14.4486 17.9865V11.9198ZM13.0749 6.96648C12.3495 6.96648 11.7615 7.55448 11.7615 8.27982V8.40115C11.7615 9.12648 12.3495 9.71448 13.0749 9.71448H13.1962C13.9215 9.71448 14.5095 9.12648 14.5095 8.40115V8.27982C14.5095 7.55448 13.9215 6.96648 13.1962 6.96648H13.0749ZM13.1353 0.899817C6.379 0.899817 0.901953 6.37687 0.901953 13.1332C0.901953 19.8894 6.379 25.3665 13.1353 25.3665C19.8916 25.3665 25.3686 19.8894 25.3686 13.1332C25.3686 6.37687 19.8916 0.899817 13.1353 0.899817ZM3.52862 13.1332C3.52862 7.82753 7.82967 3.52648 13.1353 3.52648C18.4409 3.52648 22.742 7.82753 22.742 13.1332C22.742 18.4388 18.4409 22.7398 13.1353 22.7398C7.82967 22.7398 3.52862 18.4388 3.52862 13.1332Z"
                                fill="#31344E"
                                stroke="#31344E"
                                strokeWidth="0.2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                        )}
                      </div>
                      {assessmentTestType === TestType.five_x_sit_stand && (
                        <>
                          <div className="d-flex justify-content-around">
                            <div>
                              <p className="mobilityLevel">High Mobility</p>
                              <p className="mobilityValue"> &lt;/=8 sec </p>
                            </div>
                            <div>
                              <p className="mobilityLevel">Medium Mobility</p>
                              <p className="mobilityValue">8.1 - 15 sec</p>
                            </div>
                            <div>
                              <p className="mobilityLevel">Low Mobility</p>
                              <p className="mobilityValue"> &gt;15 Seconds </p>
                            </div>
                          </div>
                          <div className="borderBottom"></div>
                          <div className="key-card-grid">
                            <div className="inner-flex">
                              <div className="rounded-box green"></div>
                              <h4 className="rounded-box-label">Acceptable</h4>
                            </div>
                            <div className="inner-flex">
                              <div className="rounded-box orange"></div>
                              <h4 className="rounded-box-label">
                                Action <br></br> Optional
                              </h4>
                            </div>
                            <div className="inner-flex">
                              <div className="rounded-box red"></div>
                              <h4 className="rounded-box-label">
                                Action <br></br> Needed
                              </h4>
                            </div>
                          </div>
                        </>
                      )}
                      {assessmentTestType === TestType.gait && (
                        <>
                          <div className="d-flex justify-content-around">
                            <div>
                              <p className="mobilityLevel">High Mobility</p>
                              <p className="mobilityValue"> &lt;40% </p>
                            </div>
                            <div>
                              <p className="mobilityLevel">Medium Mobility</p>
                              <p className="mobilityValue">40.0% - 51.2% </p>
                            </div>

                            <div>
                              <p className="mobilityLevel">Low Mobility</p>
                              <p className="mobilityValue"> &gt;51.2% </p>
                            </div>
                          </div>
                          <div className="borderBottom"></div>
                          <div className="key-card-grid">
                            <div className="inner-flex">
                              <div className="rounded-box green"></div>
                              <h4 className="rounded-box-label">Acceptable</h4>
                            </div>
                            <div className="inner-flex">
                              <div className="rounded-box orange"></div>
                              <h4 className="rounded-box-label">
                                Action <br></br> Optional
                              </h4>
                            </div>
                            <div className="inner-flex">
                              <div className="rounded-box red"></div>
                              <h4 className="rounded-box-label">
                                Action <br></br> Needed
                              </h4>
                            </div>
                          </div>
                        </>
                      )}
                      {assessmentTestType === TestType.reach && (
                        <>
                          <div className="d-flex justify-content-around">
                            <div>
                              <p className="mobilityLevel">High Mobility</p>
                              <p className="mobilityValue"> &gt;10 sec </p>
                            </div>
                            <div>
                              <p className="mobilityLevel">Medium Mobility</p>
                              <p className="mobilityValue">6-10 sec </p>
                            </div>

                            <div>
                              <p className="mobilityLevel">Low Mobility</p>
                              <p className="mobilityValue"> &lt;6 sec </p>
                            </div>
                          </div>
                          <div className="borderBottom"></div>
                          <div className="key-card-grid">
                            <div className="inner-flex">
                              <div className="rounded-box green"></div>
                              <h4 className="rounded-box-label">Acceptable</h4>
                            </div>
                            <div className="inner-flex">
                              <div className="rounded-box orange"></div>
                              <h4 className="rounded-box-label">
                                Action <br></br> Optional
                              </h4>
                            </div>
                            <div className="inner-flex">
                              <div className="rounded-box red"></div>
                              <h4 className="rounded-box-label">
                                Action <br></br> Needed
                              </h4>
                            </div>
                          </div>
                        </>
                      )}
                      {assessmentTestType === TestType.tug && (
                        <>
                          <div className="d-flex justify-content-around">
                            <div>
                              <p className="mobilityLevel">High Mobility</p>
                              <p className="mobilityValue"> &lt;10 sec </p>
                            </div>
                            <div>
                              <p className="mobilityLevel">Medium Mobility</p>
                              <p className="mobilityValue">10-14 sec </p>
                            </div>

                            <div>
                              <p className="mobilityLevel">Low Mobility</p>
                              <p className="mobilityValue"> &gt;14 sec </p>
                            </div>
                          </div>
                          <div className="borderBottom"></div>
                          <div className="key-card-grid">
                            <div className="inner-flex">
                              <div className="rounded-box green"></div>
                              <h4 className="rounded-box-label">Acceptable</h4>
                            </div>
                            <div className="inner-flex">
                              <div className="rounded-box orange"></div>
                              <h4 className="rounded-box-label">
                                Action <br></br> Optional
                              </h4>
                            </div>
                            <div className="inner-flex">
                              <div className="rounded-box red"></div>
                              <h4 className="rounded-box-label">
                                Action <br></br> Needed
                              </h4>
                            </div>
                          </div>
                        </>
                      )}
                      {assessmentTestType === TestType.ctsib && (
                        <>
                          <div className="d-flex justify-content-around">
                            <div>
                              <p className="mobilityLevel">High Mobility</p>
                            </div>
                            <div>
                              <p className="mobilityLevel">Medium Mobility</p>
                            </div>

                            <div>
                              <p className="mobilityLevel">Low Mobility</p>
                            </div>
                          </div>
                          <div className="borderBottom"></div>
                          <div className="key-card-grid">
                            <div className="inner-flex">
                              <div className="rounded-box green"></div>
                              <h4 className="rounded-box-label">Acceptable</h4>
                            </div>
                            <div className="inner-flex">
                              <div className="rounded-box orange"></div>
                              <h4 className="rounded-box-label">
                                Action <br></br> Optional
                              </h4>
                            </div>
                            <div className="inner-flex">
                              <div className="rounded-box red"></div>
                              <h4 className="rounded-box-label">
                                Action <br></br> Needed
                              </h4>
                            </div>
                          </div>
                        </>
                      )}

                      <div className="key-card-grid">
                        {/* <div className="inner-flex">
                  <div className="rounded-box green"></div>
                  <h4 className="rounded-box-label">Acceptable</h4>
                </div>
                <div className="inner-flex">
                  <div className="rounded-box orange"></div>
                  <h4 className="rounded-box-label">
                    Action <br></br> Optional
                  </h4>
                </div>
                <div className="inner-flex">
                  <div className="rounded-box red"></div>
                  <h4 className="rounded-box-label">
                    Action <br></br> Needed
                  </h4>
                </div> */}
                        {assessmentTestType === TestType.upper_body_arom && (
                          <>
                            <div className="inner-flex">
                              <div className="rounded-box blue"></div>
                              <h4 className="rounded-box-label">Left</h4>
                            </div>
                            <div className="inner-flex">
                              <div className="rounded-box dark-red"></div>
                              <h4 className="rounded-box-label">Right</h4>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {assessmentTestType === TestType.gait && (
                  <div className="assement-notes-card-main-wrap">
                    <IonLabel className="label" placeholder={undefined}>
                      References
                    </IonLabel>
                    <div className="assement-notes-card notes-margin-bottom">
                      <ol type="1" className="reference-list">
                        <li>
                          Levine DF, Richards J, Whittle M. (2012). Whittle's
                          Gait Analysis Whittle's Gait Analysis Elsevier Health
                          Sciences. ISBN 978-0702042652
                        </li>
                      </ol>
                    </div>
                  </div>
                )}
                {assessmentTestType === TestType.five_x_sit_stand && (
                  <div className="assement-notes-card-main-wrap">
                    <IonLabel className="label" placeholder={undefined}>
                      References
                    </IonLabel>
                    <div className="assement-notes-card notes-margin-bottom">
                      <ol className="reference-list">
                        <li>
                          Bohannon, R.W. (2006). Reference values from the
                          five-repetition sit - to - stand test: a descriptive
                          meta - analysis of data from elders Percept Mot Skills
                          103(1):215-222.
                        </li>
                        <li>
                          Five-repetition sit-to-stand test performance by
                          community -dwelling adults: A preliminary
                          investigation of times, deterinants, and relationship
                          with self-reported physical performance Bohannon,
                          Richard W. | Shove, Megan E. | Barreca, Susan R.; |
                          Masters, Lisa M. | Sigouin, Christopher S.
                        </li>
                      </ol>
                    </div>
                  </div>
                )}
                {assessmentTestType === TestType.tug && (
                  <div className="assement-notes-card-main-wrap">
                    <IonLabel className="label" placeholder={undefined}>
                      References
                    </IonLabel>
                    <div className="assement-notes-card notes-margin-bottom">
                      <ol className="reference-list">
                        <li>
                          Podsiadlo, D; Richardson, S (1991). The timed Up and
                          Go: A test of basic functional mobility for frail
                          elderly persons. Journal of the American Geriatrics
                          Society. 39 (2): 142-8.
                        </li>
                        <li>
                          Age and gender-related test performace in
                          community-dwelling elderly people: Six-Minute Walk
                          Test, Ber Balance Scale, Timed Up and Go Test, and
                          gait speeds. Teresa M Steffen, Timothy A Hacker,
                          Louise Mollinger
                        </li>
                      </ol>
                    </div>
                  </div>
                )}
                {assessmentTestType === TestType.reach && (
                  <div className="assement-notes-card-main-wrap">
                    <IonLabel className="label" placeholder={undefined}>
                      References
                    </IonLabel>
                    <div className="assement-notes-card notes-margin-bottom">
                      <ol className="reference-list">
                        <li>
                          O’Sullivan, Susan; Schmitz, Thomas (2007). Physical
                          Rehabilitation (Fifth ed.). Philadelphia: F.A. Davis
                          Company. pp. 254-259. - Duncan PW, Weiner DK, Chandler
                          J, Studenski S. Functional reach:a new clinical
                          measure of balance. J Gerontol 1990; 45; M192-M197
                        </li>
                        <li>
                          Duncan PW, Weiner DK, Chandler J, Studenski S.
                          Functional Reach: a new clinical measure. J Ger, 45:
                          M192-197, 1990
                        </li>
                      </ol>
                    </div>
                  </div>
                )}
              </>
            )}
          </IonGrid>
        ) : !isFullPatient ? (
          <Loader></Loader>
        ) : null}
      </IonContent>
      <IonFooter
        className="ion-no-border assessment-footer"
        placeholder={undefined}
      >
        {/* <Footer></Footer> */}
        <IonGrid className="container" placeholder={undefined}>
          <IonRow className="row" placeholder={undefined}>
            <IonCol className="col-sec" placeholder={undefined}>
              <div className="btn-wrap-sec">
                <IonButton
                  className="generic-btn excercise-plan-btn"
                  placeholder={undefined}
                  onClick={() => redirectBackToExercisePage()}
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="18" height="18" fill="white" />
                    <path
                      d="M11.7555 2.84687C11.4399 4.1125 10.3024 5 8.99925 5C7.69612 5 6.55862 4.1125 6.243 2.84687L5.968 1.75625C5.83675 1.22188 5.293 0.896875 4.7555 1.03125C4.218 1.16563 3.89612 1.70625 4.0305 2.24375L4.30237 3.33437C4.64612 4.70937 5.55862 5.82188 6.74925 6.44688V16C6.74925 16.5531 7.19612 17 7.74925 17C8.30237 17 8.74925 16.5531 8.74925 16V12H9.24925V16C9.24925 16.5531 9.69612 17 10.2492 17C10.8024 17 11.2492 16.5531 11.2492 16V6.44688C12.4399 5.82188 13.3524 4.70937 13.6961 3.33437L13.968 2.24375C14.1024 1.70937 13.7774 1.16563 13.2399 1.03125C12.7024 0.896875 12.1617 1.22188 12.0305 1.75625L11.7586 2.84687H11.7555ZM8.99925 4C9.39707 4 9.7786 3.84196 10.0599 3.56066C10.3412 3.27936 10.4992 2.89782 10.4992 2.5C10.4992 2.10218 10.3412 1.72064 10.0599 1.43934C9.7786 1.15804 9.39707 1 8.99925 1C8.60142 1 8.21989 1.15804 7.93859 1.43934C7.65728 1.72064 7.49925 2.10218 7.49925 2.5C7.49925 2.89782 7.65728 3.27936 7.93859 3.56066C8.21989 3.84196 8.60142 4 8.99925 4Z"
                      fill="#005A75"
                    />
                  </svg>
                  Create an Exercise Plan
                </IonButton>
              </div>
              <div className="btn-wrap-sec">
                <IonButton
                  className="generic-btn bg-blue"
                  placeholder={undefined}
                  onClick={() => redirectBackToPatientPage()}
                >
                  <svg
                    width="21"
                    height="22"
                    viewBox="0 0 21 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="c-plus-icon"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M9.7045 6.8295C10.1438 6.39017 10.8562 6.39016 11.2955 6.8295L14.6705 10.2045C14.8815 10.4155 15 10.7016 15 11C15 11.2984 14.8815 11.5845 14.6705 11.7955L11.2955 15.1705C10.8562 15.6098 10.1438 15.6098 9.7045 15.1705C9.26517 14.7312 9.26516 14.0188 9.7045 13.5795L11.159 12.125H1.5C0.87868 12.125 0.375 11.6213 0.375 11C0.375 10.3787 0.87868 9.875 1.5 9.875L11.159 9.875L9.7045 8.4205C9.26517 7.98115 9.26516 7.26885 9.7045 6.8295Z"
                      fill="white"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0.375 3.125C0.375 1.88236 1.38236 0.875 2.625 0.875H18.375C19.6176 0.875 20.625 1.88236 20.625 3.125V18.875C20.625 20.1176 19.6176 21.125 18.375 21.125H2.625C1.38236 21.125 0.375 20.1176 0.375 18.875V16.625C0.375 16.0037 0.87868 15.5 1.5 15.5C2.12132 15.5 2.625 16.0037 2.625 16.625V18.875H18.375V3.125H2.625V5.375C2.625 5.99632 2.12132 6.5 1.5 6.5C0.87868 6.5 0.375 5.99632 0.375 5.375V3.125Z"
                      fill="white"
                    />
                  </svg>
                  Save and Exit Summary
                </IonButton>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonFooter>
    </IonPage>
  );
};
export default PatientAssessmentSummary;
